module.exports = __webpack_public_path__ + "static/media/lc.1ff12725.svg";